import { useHistory } from 'react-router-dom';

type LogoSize = 'sm' | 'md' | 'lg';

const cfg: Record<LogoSize, { circle: number; tag: string; open: string }> = {
  sm: { circle: 28, tag: '0.58rem', open: '1.05rem' },
  md: { circle: 36, tag: '0.75rem', open: '1.4rem' },
  lg: { circle: 52, tag: '1.05rem', open: '2.1rem' },
};

export function Logo({ size = 'md' }: { size?: LogoSize }) {
  const history = useHistory();
  const c = cfg[size];
  return (
    <button
      onClick={() => history.push('/')}
      className="flex items-center gap-1.5 select-none focus:outline-none"
      aria-label="Go to home"
    >
      <span style={{ fontWeight: 900, fontSize: c.open, color: '#1a56a0', letterSpacing: '-0.02em', lineHeight: 1, fontFamily: 'Helvetica Neue, Helvetica, Arial, sans-serif' }}>
        OPEN
      </span>
      <div
        style={{ background: '#1a1a1a', borderRadius: '50%', width: c.circle, height: c.circle, flexShrink: 0 }}
        className="flex items-center justify-center"
      >
        <span style={{ fontWeight: 800, fontSize: c.tag, color: 'white', letterSpacing: '-0.03em', fontFamily: 'Helvetica Neue, Helvetica, Arial, sans-serif' }}>
          iPub
        </span>
      </div>
    </button>
  );
}
